import { Component } from "../component"

export class MarketingConfirmation extends Component {
  constructor(props) {
    super(props)
  }

  ui() {
    return {
      MarketingConfirmation: ".shopify-email-marketing-confirmation__container",
    }
  }

  hideElements() {
    const marketingSection = document.querySelector(
      this.ui().MarketingConfirmation
    )

    if (marketingSection) {
      const children = marketingSection.querySelectorAll("*")

      children.forEach((child) => {
        if (child.textContent.trim() === "hide") {
          child.style.display = "none"
        }
      })
    }
  }

  created() {
    this.hideElements()
  }
}
